export const getNumberOfStars = (rating: number | null | undefined) => {
  if (rating === null || rating === undefined) return 0
  return Math.floor(rating)
}
